import { ReactNode, useContext, useEffect, useLayoutEffect, useState } from 'react'
import { InputField } from '../inputs/InputField'
import { useForm } from 'react-hook-form'
import { inputRequiredRule } from '../../helpers/form.helper'
import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { AmbientestModuleContext } from '../../context/AmbientestModuleContext'
import AppSteps from '../navigation/AppSteps'
import FieldsetForm from './FieldsetForm'
import { FieldOptional } from '../../types'

const actualStep = 2

export default function FormPlainEnviromentData() {
    const { control, formState, handleSubmit } = useForm()
    const navigate = useNavigate()
    const context = useContext(AmbientestModuleContext)
    const [submitted, setSubmitted] = useState(false)

    function onSubmit(data: any) {
        context?.setEnvProfile(data)
        setSubmitted(true)
    }

    function toStart() {
        navigate(context?.path || '/')
    }

    useEffect(() => {
        if (!context?.userData) {
            toStart()
        }
    }, [context?.userData])

    useEffect(() => {
        if (!submitted) {
            return
        }

        if ((context?.steps.length || 0) > actualStep) {
            navigate(`${context?.path}/documentos`)
        } else {
            context?.requestUserEnviroment()
            setSubmitted(false)
        }
    }, [submitted, context?.steps])

    return (
        <div>
            <AppSteps steps={context?.steps || []} actualStep={actualStep} />
            <form
                className="form-contain business"
                onSubmit={handleSubmit(onSubmit)}
                autoComplete="off"
            >
                <FieldsetForm title='Información del trabajador'>
                    <div className='form-contain-row'>
                        <div>
                            <InputField
                                controller={{
                                    name: "curp",
                                    control: control,
                                    defaultValue: context?.userData?.curp || '',
                                    rules: { ...inputRequiredRule }
                                }}
                                inputProps={{
                                    maxLength: 18
                                }}
                                errors={formState.errors}
                                disabled={!!context?.userData?.curp}
                                label="Curp*"
                            />
                        </div>
                        <div>
                            <InputField
                                controller={{
                                    name: "name",
                                    control: control,
                                    defaultValue: context?.userData?.name || '',
                                    rules: { ...inputRequiredRule }
                                }}
                                errors={formState.errors}
                                disabled={!!context?.userData?.name}
                                label="Nombre*"
                            />
                        </div>
                    </div>
                    <div className='form-contain-row'>
                        <div>
                            <InputField
                                controller={{
                                    name: "lastName",
                                    control: control,
                                    defaultValue: context?.userData?.lastName || '',
                                    rules: { ...inputRequiredRule }
                                }}
                                disabled={!!context?.userData?.lastName}
                                errors={formState.errors}
                                label="Apellido Paterno*"
                            />
                        </div>
                        <div>
                            <InputField
                                controller={{
                                    name: "secondLastName",
                                    control: control,
                                    defaultValue: context?.userData?.secondLastName || '',
                                    rules: { ...inputRequiredRule }
                                }}
                                disabled={!!context?.userData?.secondLastName && !!context?.userData?.curp}
                                errors={formState.errors}
                                label="Apellido Materno*"
                            />
                        </div>
                    </div>
                    <div className='form-contain-row'>
                        <div>
                            <InputField
                                controller={{
                                    name: "birthDate",
                                    control: control,
                                    defaultValue: context?.userData?.birthDate || '',
                                    rules: { ...inputRequiredRule }
                                }}
                                disabled={!!context?.userData?.birthDate}
                                errors={formState.errors}
                                label="Fecha de nacimiento*"
                            />
                        </div>
                        <div>
                            <InputField
                                controller={{
                                    name: "gender",
                                    control: control,
                                    defaultValue: context?.userData?.gender || '',
                                    rules: { ...inputRequiredRule }
                                }}
                                disabled={!!context?.userData?.gender}
                                errors={formState.errors}
                                label="Genero*"
                            />
                        </div>
                    </div>
                    <div className='form-contain-row'>
                        <div>
                            <InputField
                                controller={{
                                    name: "birthFederalState",
                                    control: control,
                                    defaultValue: context?.federalStates.find(f => [f.alphabeticCode, f.id].includes(context?.userData?.birthFederalState || ''))?.code || '',
                                    rules: { ...inputRequiredRule }
                                }}
                                errors={formState.errors}
                                options={context?.federalStates.map(f => ({ label: f.name, value: f.code })) || []}
                                label="Entidad Federativa de Nacimiento*"
                                disabled={!!context?.userData?.birthFederalState}
                            />
                        </div>
                        {context?.formFields.requestImssName && <div>
                            <InputField
                                controller={{
                                    name: "imssName",
                                    control: control,
                                    defaultValue: [context?.userData?.lastName || '', context?.userData?.secondLastName || '', context?.userData?.name || ''].join('$') || '',
                                    rules: { ...inputRequiredRule }
                                }}
                                errors={formState.errors}
                                label="Nombre IMSS*"
                                disabled={!!context?.userData?.lastName}
                            />
                        </div>}
                    </div>
                    <div className="form-contain-row">
                        {context?.formFields.requestNss && <div>
                            <InputField
                                controller={{
                                    name: "nss",
                                    control: control,
                                    defaultValue: context?.userData?.nss || '',
                                    rules: checkOptional(context?.formFields.requestNss) ? {} : { ...inputRequiredRule }
                                }}
                                inputProps={{
                                    maxLength: 11
                                }}
                                errors={formState.errors}
                                label={`NSS${checkOptional(context?.formFields.requestNss) ? '' : '*'}`}
                            />
                        </div>}
                        {context?.formFields.requestAfore && <div>
                            <InputField
                                controller={{
                                    name: "aforeCode",
                                    control: control,
                                    defaultValue: context?.userData?.aforeCode || '',
                                    rules: { ...inputRequiredRule }
                                }}
                                errors={formState.errors}
                                label="Afore*"
                                options={context?.afores}
                                disabled={context?.afores.length === 0}
                            />
                        </div>}
                    </div>
                    {context?.formFields.requestContactInfo && <div className="form-contain-row">
                        <div>
                            <InputField
                                controller={{
                                    name: "phoneNumber",
                                    control: control,
                                    defaultValue: context?.userData?.phoneNumber || '',
                                    rules: {
                                        ...inputRequiredRule,
                                        maxLength: {
                                            value: 10,
                                            message: "El número celular debe ser de 10 digitos."
                                        },
                                        minLength: {
                                            value: 10,
                                            message: "El número celular debe ser de 10 digitos."
                                        },
                                    }
                                }}
                                inputProps={{
                                    maxLength: 10
                                }}
                                errors={formState.errors}
                                label={`Número Celular*`}
                            />
                        </div>
                        <div>
                            <InputField
                                controller={{
                                    name: "email",
                                    control: control,
                                    defaultValue: context?.userData?.email || '',
                                    rules: { ...inputRequiredRule }
                                }}
                                errors={formState.errors}
                                label="Correo electrónico*"
                            />
                        </div>
                    </div>}
                </FieldsetForm>
                <div className="form-contain-row">
                    <div>
                        <Button
                            variant='outlined'
                            fullWidth
                            onClick={toStart}
                        >
                            Cancelar
                        </Button></div>
                    <div>
                        <Button
                            type='submit'
                            className='app-btn-color'
                            fullWidth
                        >
                            Aceptar
                        </Button>
                    </div>
                </div>
            </form>
        </div>
    )
}


function checkOptional(field?: FieldOptional) {
    return field && typeof field === 'object' && field.optional
}
